<style scoped>
main {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
}
.thank-icon {
	width: 96px;
	height: 96px;
	border-radius: 50%;
	background-color: #d1e7dd;
	color: #198754;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}
.thank-icon i {
	font-size: 3rem;
}
.thank-title {
	font-size: 2rem;
	font-weight: 600;
}
.urgent-box {
	background-color: #fff3cd;
	border: 1px solid #ffecb5;
	border-radius: 0.5rem;
	padding: 0.9rem 1.25rem;
}
</style>
<template>
	<main class="text-center py-2">
		<div class="thank-icon mb-3">
			<i class="bi bi-check-circle"></i>
		</div>
		<h2 class="thank-title mb-4">{{ t("thank_you_title") }}</h2>

		<div class="alert alert-light border text-start mb-3 py-3">
			<p class="mb-0 fs-5">{{ t("thank_you_body") }}</p>
		</div>

		<div
			v-if="org.phone"
			class="urgent-box text-start d-flex align-items-start gap-2"
		>
			<i class="bi bi-telephone text-warning-emphasis mt-1 fs-5"></i>
			<div>
				<strong class="d-block fs-6">{{ t("call_urgent") }}</strong>
				<a class="fs-2 fw-bold text-decoration-none" :href="telHref">
					{{ org.phone }}
				</a>
			</div>
		</div>

		<div class="mt-4">
			<button
				type="button"
				class="btn btn-primary btn-lg w-100"
				:disabled="renewing"
				@click="doRenew"
			>
				<i class="bi bi-arrow-repeat me-1"></i>
				<span
					v-if="renewing"
					class="spinner-border spinner-border-sm me-1"
				></span>
				{{ t("check_again") }}
			</button>
		</div>
	</main>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useOrg, useT } from "@/rmo/content/mosquito/copy";
import { useRoutes } from "@/rmo/route/use";
import { useStoreVirtualInspection } from "@/rmo/store/virtualinspection";

const props = defineProps<{
	token: string;
}>();

const t = useT();
const org = computed(useOrg);
const telHref = computed(() => `tel:+${org.value.phone.replace(/\D/g, "")}`);
const router = useRouter();
const routes = useRoutes();
const store = useStoreVirtualInspection();
const renewing = ref(false);

async function doRenew() {
	renewing.value = true;
	const newToken = await store.renew(props.token);
	if (newToken) {
		// Load the fresh round so the shell renders it (state was cleared).
		const s = await store.fetchState(newToken).catch(() => null);
		if (s) {
			router.replace(routes.MosquitoCheckWelcome(newToken));
		}
	}
	renewing.value = false;
}
</script>
